<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">

      <!--
            <div>
              <label for="id">ID:</label>
              <input id="id" type="text" placeholder="Enter ID" class="form-input" formControlName="id" />
              <form-error [form]="form" controlName="id" [validations]="MasterDepositFormValidations.id"></form-error>
            </div> -->


      <!-- Single File -->
      <div class="panel" *ngIf=" !imagePreviewUrl ||  imagePreviewUrl == ''">
        <div class="mb-5 flex items-center justify-between">
          <h5 class="text-lg font-semibold dark:text-white-light">Single File Upload</h5>
          <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;"
             (click)="toggleCode('code1')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
          </a>
        </div>
        <div class="mb-5">
          <div class="custom-file-container" data-upload-id="myFirstImage">
            <input
              (change)="onImageSelected($event)"
              style="display: none"
            />
          </div>
        </div>
        <ng-container *ngIf="codeArr.includes('code1')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- single file --&gt;
&lt;div class=&quot;custom-file-container&quot; data-upload-id=&quot;myFirstImage&quot;&gt;&lt;/div&gt;

&lt;!-- script --&gt;
ngOnInit() {
    // single image upload
    new FileUploadWithPreview('myFirstImage', {
        images: {
            baseImage: '/assets/images/file-preview.svg',
            backgroundImage: '',
        },
    });
}"></code> </pre>
        </ng-container>
        <form-error
          [form]="form"
          controlName="file"
          [validations]="MasterDepositFormValidations.file">
        </form-error>
      </div>

      <div *ngIf="imagePreviewUrl">
        <div class="w-full max-w-md mx-auto">
          <img
            [src]="imagePreviewUrl"
            alt="Image preview"
            class="w-full h-auto border rounded shadow object-contain"
          />
        </div>
      </div>

      <div *ngIf="imagePreviewUrl">
        <label>Status:</label>
        <ng-select
          [items]="statuses"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select status"
          class="custom-multiselect w-full"
          formControlName="status"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="status"
          [validations]="MasterDepositFormValidations.status"></form-error>
      </div>


      <div>
        <label for="amount">Amount:</label>
        <input
          id="amount" type="number" placeholder="Enter Amount" class="form-input" formControlName="amount"
          [attr.disabled]="imagePreviewUrl ? true : null"
        />
        <form-error [form]="form" controlName="amount" [validations]="MasterDepositFormValidations.amount"></form-error>
      </div>


      <button
        [disabled]="form.invalid"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
